export default "__VITE_ASSET__D8G8k6OH__"